export const green = {
    50: '#EAF9F1',
    100: '#D5F2E3',
    150: '#C1ECD4',
    200: '#ACE5C6',
    300: '#82D9AA',
    400: '#59CC8D',
    500: '#2CB46B',
    600: '#2D8658',
    700: '#1A6A42',
    800: '#145238',
    850: '#0E3922',
    900: '#092617',
    950: '#05130B'
};

//# sourceMappingURL=green.js.map